import { render, staticRenderFns } from "./MenuUpdateCategory.vue?vue&type=template&id=1c689d46&scoped=true"
import script from "./MenuUpdateCategory.vue?vue&type=script&lang=ts"
export * from "./MenuUpdateCategory.vue?vue&type=script&lang=ts"
import style0 from "./MenuUpdateCategory.vue?vue&type=style&index=0&id=1c689d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c689d46",
  null
  
)

export default component.exports